import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Button, MobileStepper } from '@mui/material';
import React from 'react'

type Props = {
  CurrTabKey: string;
  set_CurrTabKey: React.Dispatch<React.SetStateAction<string>>;
  TAB_KEY_LIST: string[];
  OnStepperChanged: (curr_tab_key: string) => void;
}

const UcStepper = ({ CurrTabKey, set_CurrTabKey, TAB_KEY_LIST, OnStepperChanged }: Props) => {

  // const ctx = useAppContext();


  return (<MobileStepper variant="dots" position="static"
    steps={TAB_KEY_LIST.length}

    activeStep={TAB_KEY_LIST.indexOf(CurrTabKey)}
    sx={{ bgcolor: '#DDDDDD' }}

    nextButton={
      <div>
        <Button disabled={TAB_KEY_LIST.indexOf(CurrTabKey) === TAB_KEY_LIST.length - 1}
          onClick={(e) => {
            const next_index = TAB_KEY_LIST.indexOf(CurrTabKey) + 1;
            const curr_tab_key = TAB_KEY_LIST[next_index];
            set_CurrTabKey(curr_tab_key);

            ScrollToTop(e);

            OnStepperChanged(curr_tab_key);

          }}
        >
          下一頁
          <KeyboardArrowRight />
        </Button>
      </div>
    }

    backButton={
      <Button disabled={TAB_KEY_LIST.indexOf(CurrTabKey) === 0}
        onClick={(e) => {
          const prev_index = TAB_KEY_LIST.indexOf(CurrTabKey) - 1;
          const curr_tab_key = TAB_KEY_LIST[prev_index];
          set_CurrTabKey(curr_tab_key);

          ScrollToTop(e);

          OnStepperChanged(curr_tab_key);

        }}
      >
        <KeyboardArrowLeft />
        上一頁
      </Button>
    }

  />);
}

function ScrollToTop(e: any) {
  const anchor = (
    (e.target as HTMLDivElement).ownerDocument || document
  ).querySelector('#back-to-top-anchor')// 找到文件中的錨點，並捲過去

  if (anchor) {
    anchor.scrollIntoView({
      block: 'center',
    })
  }
}

export default UcStepper